var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEchooo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 397,
    height: 74,
    viewBox: "0 0 397 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_1249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 44.7C0 22.1 19.3 13.7 35.3 13.7C53.3 13.7 63.7 22 63.7 37.1C63.7 39.2 63.4 41.5 63 44L33.3 45C34.8 48.8 38.3 50.7 44.7 50.7C49.2 50.7 53.7 50 59.7 46.5C61.3 47.1 62.9 50.5 62.9 54.6C62.9 62.6 57.1 73.5 34.7 73.5C10.9 73.5 0 61.2 0 44.7ZM32.3 39L40 37.9C40.9 34.1 40.1 28.9 37 28.9C34.6 28.9 32.3 32.7 32.3 38.6V39Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4 44.7C59.4 27.9 72.2 13.8 94.2 13.8C100.5 13.8 110.5 15.5 116.3 14.8C117.9 18.1 118.4 22.8 118.4 25.2C118.4 32.3 114.9 36.9 107.8 36.9C103 36.9 98.5 34.3 93.2 29.7C92 31.7 92 33.7 92 35.1C92 40.8 96.1 45.3 104.8 45.3C109.3 45.3 113.7 43.7 117 41.6C118.4 44.7 119.1 48 119.1 51.1C119.1 62.9 110.5 72.7 91.8 72.7C74.1 72.7 59.4 62.4 59.4 44.7Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.1 50.3C155.1 46.7 155.5 42.6 156.4 38.4C155.9 38.1 155.3 37.9 154.8 37.9C152.2 37.9 150.5 40.2 150.5 48.1V71.3H116.3L117.3 39.3C117.9 19.4 116.2 11.3 114.5 5.4C119.4 1.9 125.4 0 133.1 0C144.9 0 150.9 5.1 150.9 17.8C150.9 21.1 150.5 25 149.1 29.5H151.1C154 20 161.7 13.8 172.6 13.8C184.5 13.8 190.8 21.6 189.6 34.3L188.8 42.9C188.5 45.8 190 46.8 192.2 46.8C193.1 46.8 194.7 46.5 195.8 45.8C196.7 48.3 197.1 50.7 197.1 53C197.1 63.9 188 72.7 174.6 72.7C161.2 72.7 155.1 65.3 155.1 50.3Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.8 44.4C191.8 25.8 206 13.3 228.3 13.3C249.1 13.3 262.8 24.7 262.8 43C262.8 61.3 248.4 73.2 226.3 73.2C205.8 73.2 191.8 62 191.8 44.4ZM231.3 42.6C231.3 35.6 229.8 31.9 227.3 31.9C224.8 31.9 223.3 35.8 223.3 43.5C223.3 50.5 224.8 54.2 227.3 54.2C229.8 54.2 231.3 50.3 231.3 42.6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.5 44.4C258.5 25.8 272.7 13.3 295 13.3C315.8 13.3 329.5 24.7 329.5 43C329.5 61.3 315.1 73.2 293 73.2C272.5 73.2 258.5 62 258.5 44.4ZM298 42.6C298 35.6 296.5 31.9 294 31.9C291.5 31.9 290 35.8 290 43.5C290 50.5 291.5 54.2 294 54.2C296.5 54.2 298 50.3 298 42.6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.2 44.4C325.2 25.8 339.4 13.3 361.7 13.3C382.5 13.3 396.2 24.7 396.2 43C396.2 61.3 381.8 73.2 359.7 73.2C339.2 73.2 325.2 62 325.2 44.4ZM364.7 42.6C364.7 35.6 363.2 31.9 360.7 31.9C358.2 31.9 356.7 35.8 356.7 43.5C356.7 50.5 358.2 54.2 360.7 54.2C363.2 54.2 364.7 50.3 364.7 42.6Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_1249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 396.2,
    height: 73.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEchooo);
export default __webpack_public_path__ + "static/media/echooo.2c7fad6af080981a83bd747789725867.svg";
export { ForwardRef as ReactComponent };